/**
 * Creates a link to Google Maps for directions to the destination. If the
 * 'origin' is omitted, then it will default to the best known location if
 * available.
 * More info: https://developers.google.com/maps/documentation/urls/get-started#directions-action
 */
export const getGoogleMapsDirectionsLink = ({
  origin = '',
  destination,
}: {
  origin?: string;
  destination: string;
}): string =>
  `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(
    origin,
  )}&destination=${encodeURIComponent(destination)}`;

export const FEDEX_DELIVERY_MANAGER_LINK =
  'https://www.fedex.com/en-us/delivery-manager.html';
